export default "__VITE_ASSET__Cwb_3Y8M__"